import styled from 'styled-components'

export const ShellContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export const ShellBody = styled.div<any>`
  display: flex;
  flex: 1;
  transition: all 0.3s ease;
`

export const MainContent = styled.div<any>`
  flex: 1;
  min-width: 0;
  transition: all 0.3s ease;
`
